export const getBackURL = () => {
  let backUrl = "/";
  if (typeof window !== "undefined") {
    backUrl = window.location.pathname;
  }
  return backUrl;
};
